<div class="content-block">


  <div class="row">
    <div class="col-12">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h2 class="content-block">Nuova consegna </h2>
        <div class="d-flex gap-2">

        </div>
      </div>
    </div>
  </div>


  <div class="row g-3 mb-3">
    <div class="col-12 col-lg-6">
      <div class="card p-3">
        <!--<h3 class="card-title font-weight-bold">Nuova consegna</h3>-->
        <form id="form-nuova-consegna">
          <dx-validation-group>
            <div class="row">
              <div class="col-md-4">
                <div class="dx-fieldset-header">Dipendente</div>
                <dx-lookup #dipendente displayExpr="nominativo" valueExpr="id" [items]="listDip" [searchEnabled]="true"
                  [(value)]="nuovoMovimento.idDipendente" (onValueChanged)="dipendenteSelected($event)">

                  <dx-validator>
                    <dxi-validation-rule type="required" message="Selezionare il dipendente"></dxi-validation-rule>
                  </dx-validator>
                </dx-lookup>
              </div>

              <div class="col-md-4">
                <div class="dx-fieldset-header">Data</div>
                <dx-date-box #data displayFormat=" dd/MM/yyyy" [(value)]="dataMovimento" [height]="26">
                  <dx-validator>
                    <dxi-validation-rule type="required" message="Selezionare la data"></dxi-validation-rule>
                  </dx-validator>
                </dx-date-box>

              </div>
              <div class="col-md-4">
                <div class="dx-fieldset-header">Categoria</div>
                <dx-lookup #categoria displayExpr="descrizione" valueExpr="id" [items]="listCatArticoli"
                  [searchEnabled]="true" [(value)]="idCatArticolo"
                  [disabled]="nuovoMovimento.listDettaglio?.length > 0 || hasEditingDetail()"
                  (onValueChanged)="catArticoloSelected($event)">

                  <dx-validator>
                    <dxi-validation-rule type="required" message="Selezionare la categoria"></dxi-validation-rule>
                  </dx-validator>
                </dx-lookup>
              </div>
            </div>

            <div class="row">
              <div class="col-12">&nbsp;</div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <!--
                Selezione riga senza key
                [selection]="{ mode: 'single' }"
                (onSelectionChanged)="rowChanged($event)"
                -->
                <dx-data-grid #gridDettaglioMov [dataSource]="nuovoMovimento.listDettaglio" keyExpr="idArticolo"
                  [showBorders]="true" [focusedRowEnabled]="true" [focusedRowIndex]="0" [columnAutoWidth]="true"
                  [columnHidingEnabled]="false" (onEditorPreparing)="onEditorPreparing($event)"
                  (onInitNewRow)="onInitNewRow($event)" (onToolbarPreparing)="onToolbarPreparing($event)"
                  (onFocusedRowChanged)="onFocusedRowChanged($event)" (onRowInserting)="onRowInserting($event)"
                  (onRowInserted)="onRowInserted($event)" (onRowUpdated)="rowUpdated($event)" (onEditCanceled)="onEditCanceled($event)">

                  <dxo-editing mode="row" [allowAdding]="true" [allowUpdating]="true" [allowDeleting]="true"
                    [useIcons]="true">
                  </dxo-editing>
                  <dxi-column type="buttons" width="50px">
                    <dxi-button name="edit"></dxi-button>
                    <dxi-button name="delete" hint="Elimina articolo" [onClick]="eliminaArticolo"></dxi-button>
                  </dxi-column>
                  <dxi-column name="detail§Matricole" [allowFiltering]="false" [allowSorting]="false"
                    cellTemplate="detailMatricole" width="35" caption="">
                  </dxi-column>
                  <div *dxTemplate="let d of 'detailMatricole'">

                    <!-- ICONA ROSSA  matricole NON validate -->
                    @if (!d.data.matricoleConvalidate && d.data.usaMatricola) {
                    <i class="dx-icon-check" style="color: red;" title="Matricole non validate">
                    </i>
                    }

                    <!-- ICONA VERDE  matricole validate -->
                    @if (d.data.matricoleConvalidate && d.data.usaMatricola) {
                    <i class="dx-icon-check" style="color: green;" title="Matricole validate">
                    </i>
                    }
                  </div>
                  <dxi-column dataField="idTipoArticolo" dataField="idTipoArticolo" caption="Tipologia" width="160px"
                    [setCellValue]="setTipoValue">
                    <dxo-lookup [dataSource]="listTipiArticoliFiltrati" valueExpr="id" displayExpr="descrizione"></dxo-lookup>
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                  </dxi-column>
                  <dxi-column dataField="idArticolo" caption="Articolo">
                    <dxo-lookup [dataSource]="getFilteredArticoli" valueExpr="id"
                      [displayExpr]="getArticoloDisplayExpr">
                    </dxo-lookup>
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                  </dxi-column>
                  <dxi-column dataField="qta" caption="Quantità" dataType="number" width="100px"
                    [setCellValue]="controllaSottoscorta">
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                  </dxi-column>
                  <dxi-column dataField="cambio" dataType="boolean" [width]="15+'%'">
                  </dxi-column>
                  <dxi-column dataField="matricoleConvalidate" dataType="boolean" width="60" [visible]="false">
                  </dxi-column>
                  <dxi-column dataField="usaMatricola" dataType="boolean" width="60" [visible]="false">
                  </dxi-column>


                  <!--
                  <dxi-column fixedPosition="left" visibleIndex="1" name="detail§Matricola" [allowFiltering]="false"
                    [allowSorting]="false" cellTemplate="detailMatricola" width="40" caption="">
                  </dxi-column>


                  <div *dxTemplate="let d of 'detailMatricola'">
                    <i *ngIf="d.data.usaMatricola" class="dx-icon-edit" (click)="openPopupMatricole(d.data)" style="cursor: pointer;"
                    data-toggle="tooltip" data-placement="top" title="modifica"></i>
                  </div>
                  -->


                </dx-data-grid>

                @if (nuovoMovimento.listDettaglio.length == 0) {
                <span class="text-danger">{{msgErrorDettaglioMov}}</span>
                }


              </div>


            </div>

            <div class="row">
              <div class="col-12">&nbsp;</div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div class="dx-fieldset-header">Dettagli</div>
                <dx-text-area #dettagli [height]="50" [(value)]="nuovoMovimento.dettagli">
                </dx-text-area>

              </div>
            </div>


            <div class="row mt-2">
              <div class="col-12">
                <dx-button stylingMode="contained" text="Salva" type="success" width="120"
                  [disabled]="!consentiSalvataggio" (onClick)="salvaMovimento($event)">
                </dx-button>
              </div>
            </div>
          </dx-validation-group>
        </form>

      </div>
    </div>
    <div class="col-12 col-lg-6">
      @if (abilitaGestioneMatricole) {
      <div class="card p-3">
        <div class="d-flex align-items-center">
          <div class="row">
            <div class="col-12">
              <div class="flex-grow-1">
                <h2 class="card-title mb-3" style="margin-top:0">
                  Matricole consegnate {{articoloRif}}
                  <span id="empStatusBadge" class="badge ms-2"
                    [style.backgroundColor]="listDettaglioRif!.listMatricoleConsegna?.length === numMaxDaconsegnare ? '#28a745' : '#dc3545'"
                    style="color: #fff; margin-left:10px;"> {{listDettaglioRif!.listMatricoleConsegna?.length}}/{{numMaxDaconsegnare}}
                  </span>
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6 gap-2 d-flex">
            <dx-lookup [displayExpr]="displayMatricola" valueExpr="id" [items]="listMatricoleDisponibiliFiltrate"
              [searchEnabled]="true" width="70%" [(value)]="idArticoloMatricolaDaAssegnare">
            </dx-lookup>
            @if (listDettaglioRif!.listMatricoleConsegna?.length < numMaxDaconsegnare) { <dx-button stylingMode="contained" class="ms-2" text=""
              type="success" icon="add" (onClick)="assegnaMatricola()">
              </dx-button>
              }
          </div>
          <div class="col-6  d-flex justify-content-end">
            @if (listDettaglioRif!.listMatricoleConsegna?.length < numMaxDaconsegnare) { <dx-button stylingMode="contained" class="ms-2"
              text="CREA/GENERA MATRICOLE" type="normal" icon="add" class="ms-2"
              (onClick)="attivaPopUpGeneraMatricole()">
              </dx-button>
              }
          </div>
        </div>
        <div class="row">
          <div class="col-12">&nbsp;</div>
        </div>
        <div class="row">
          <div class="col-12">
            <dx-data-grid #gridMatricoleConsegna [dataSource]="listDettaglioRif?.listMatricoleConsegna"
              [showBorders]="true" [showRowLines]="true" [showColumnLines]="true" [columnAutoWidth]="true">
              <dxo-paging [pageSize]="10"></dxo-paging>
              <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
              <dxo-editing mode="row" [allowAdding]="false" [allowUpdating]="false" [allowDeleting]="true"
                [useIcons]="true">
                <dxo-texts confirmDeleteMessage="Sei sicuro di voler eliminare il dettaglio?"></dxo-texts>
              </dxo-editing>
              <dxi-column type="buttons" width="40px">
                <dxi-button name="edit"></dxi-button>
                <dxi-button name="delete" hint="Elimina matricola" [onClick]="eliminaMatricolaArticolo"></dxi-button>
              </dxi-column>
              <!--<dxi-column
                dataField="index"
                caption="">
              </dxi-column>-->
              <dxi-column dataField="id" caption="Articolo Matricola">
                <dxo-lookup [dataSource]="listMatricoleDisponibili" valueExpr="id" [displayExpr]="displayMatricola">
                </dxo-lookup>
              </dxi-column>
            </dx-data-grid>
          </div>
        </div>
      </div>
      }
      @if (abilitaGestioneMatricole && isCambio) {
      <div class="card p-3">
        <div class="d-flex align-items-center">
          <div class="flex-grow-1">
            <h2 class="card-title mb-3" style="margin-top:0">
              Matricole restituite
              <span id="empStatusBadge" class="badge ms-2"
                [style.backgroundColor]="numRitirati === numMaxDaritirare ? '#28a745' : '#dc3545'"
                style="margin-left:10px; color: #fff;"> {{numRitirati}}/{{numMaxDaritirare}}
              </span>
            </h2>
          </div>
        </div>
        <div class="row">
          <div class="col-6 gap-2 d-flex">
            <dx-lookup [displayExpr]="displayMatricola" valueExpr="id" [items]="listMatricoleAssegnateDipendenteFiltrate"
              [searchEnabled]="true" width="70%" [(value)]="idArticoloMatricolaAssegnato">
            </dx-lookup>
            @if (numRitirati < numMaxDaritirare) { <dx-button stylingMode="contained" class="ms-2" text=""
              type="success" icon="add" (onClick)="assegnaRitiro()">
              </dx-button>
              }
          </div>
          <div class="col-6  d-flex justify-content-end">
          </div>
        </div>
        <div class="row">
          <div class="col-12">&nbsp;</div>
        </div>
        <div class="row">
          <div class="col-12">
            <dx-data-grid #gridMatricoleRitiro [dataSource]="listDettaglioRif?.listMatricoleRitiro" [showBorders]="true"
              [showRowLines]="true" [showColumnLines]="true" [columnAutoWidth]="true">
              <dxo-paging [pageSize]="10"></dxo-paging>
              <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
              <dxo-editing mode="row" [allowAdding]="false" [allowUpdating]="false" [allowDeleting]="true"
                [useIcons]="true">
                <dxo-texts confirmDeleteMessage="Sei sicuro di voler eliminare il dettaglio?"></dxo-texts>
              </dxo-editing>
              <dxi-column type="buttons" width="40px">
                <dxi-button name="edit"></dxi-button>
                <dxi-button name="delete" hint="Elimina matricola"
                  [onClick]="eliminaMatricolaArticoloRitiro"></dxi-button>
              </dxi-column>
              <!--<dxi-column
              dataField="index"
              caption="">
            </dxi-column>-->
              <dxi-column dataField="id" caption="Articolo Matricola">
                <dxo-lookup [dataSource]="listMatricoleAssegnateDipendente" valueExpr="id" [displayExpr]="displayMatricola">
                </dxo-lookup>
              </dxi-column>
            </dx-data-grid>
          </div>
        </div>
      </div>
      }
    </div>
  </div>

  <dx-popup [width]="'90vw'" [height]="560" [showTitle]="true" title="Articoli Previsti" [dragEnabled]="false"
    [showCloseButton]="true" container=".dx-viewport" [(visible)]="popUpVisiblePrevisti">

    <app-articoli-previsti-by-dipendente [idDipendente]="idDipendente" [idMansione]="idMansioneRif"
      [bConsultazione]="true" [tipoFiltro]="'A'" [filtro]="idCatArticolo"
      [listDettaglioBS]="listDettaglioBS"></app-articoli-previsti-by-dipendente>


  </dx-popup>

  <dx-popup [width]="800" [height]="560" [showTitle]="true" title="Articoli Consegnati" [dragEnabled]="false"
    [showCloseButton]="true" container=".dx-viewport" [(visible)]="popUpVisibleConsegne">

    <app-articoli-consegnati [idDipendente]="idDipendente" [idArticolo]="0" [filterEnable]="false"
      [bConsultazione]="false" [filtro]="idCatArticolo"
      [listDettaglio]="nuovoMovimento.listDettaglio"></app-articoli-consegnati>

  </dx-popup>


  <dx-popup [width]="500" [height]="500" [showTitle]="true" title="Genera matricole" [dragEnabled]="false"
    [showCloseButton]="true" container=".dx-viewport" [(visible)]="popUpVisibleGeneraMatricole">

    <form id="form-genera-matricole">
      <dx-validation-group>
        <div class="row">
          <div class="col-12">
            <div class="dx-field">
              <div class="dx-field-label"><b>Matricola</b></div>
              <div class="dx-field-value d-flex align-items-center">
                <dx-text-box placeholder="" maxLength="40" class="mr-3" [(value)]="matricolaNew">
                  <dx-validator>
                    <dxi-validation-rule type="required" message="Inserire la matricola"></dxi-validation-rule>
                  </dx-validator>

                </dx-text-box>
                <dx-button stylingMode="contained" class="mr-3" text="GENERA" icon="plus" type="success"
                  (onClick)="creaMatricola()"> </dx-button>

              </div>

            </div>
            <div class="dx-field">
              <div class="dx-field-label"><b>Data scadenza</b></div>
              <div class="dx-field-value">
                <dx-date-box displayFormat=" dd/MM/yyyy" [(value)]="dataScadenzaMatricole">
                  <!-- [height]="26"> -->
                  <dx-validator>
                    <dxi-validation-rule type="required" message="Inserire la data di scadenza">
                    </dxi-validation-rule>
                  </dx-validator>
                </dx-date-box>
              </div>


            </div>
            @for (prop of listPropsArtNewMatricola; track prop) {
            <div class="dx-field">
              <div class="dx-field-label"><b>{{prop.nome}}</b></div>
              <div class="dx-field-value">
                <!-- Tipo 1 (Alfanumerico)-->
                @if (prop.tipo==1) {
                <dx-text-box [(id)]="prop.chiave" valueChangeEvent="keyup" [(value)]="prop.valore" placeholder="">
                  @if (prop.obbligatorio) {
                  <dx-validator>
                    <dxi-validation-rule type="required" message="campo richiesto"></dxi-validation-rule>
                  </dx-validator>
                  }
                </dx-text-box>
                }
                <!-- Tipo 2 (Numerico)-->
                @if (prop.tipo==2) {
                <dx-number-box [(id)]="prop.chiave" [(value)]="prop.valore">
                  @if (prop.obbligatorio) {
                  <dx-validator>
                    <dxi-validation-rule type="required" message="campo richiesto"></dxi-validation-rule>
                  </dx-validator>
                  }
                </dx-number-box>
                }
                <!-- Tipo 3 (Data) -->
                @if (prop.tipo==3) {
                <dx-date-box [(id)]="prop.chiave" displayFormat="dd/MM/yyyy" [(value)]="prop.valore">
                  @if (prop.obbligatorio) {
                  <dx-validator>
                    <dxi-validation-rule type="required" message="Campo richiesto"></dxi-validation-rule>
                  </dx-validator>
                  }
                </dx-date-box>
                }
                <!-- Tipo 4 (Valori multipli) -->
                @if (prop.tipo==4) {
                <dx-lookup [(id)]="prop.chiave" [dataSource]="prop.selMultiplaDati" [(value)]="prop.valore">
                  @if (prop.obbligatorio) {
                  <dx-validator>
                    <dxi-validation-rule type="required" message="Campo richiesto"></dxi-validation-rule>
                  </dx-validator>
                  }
                </dx-lookup>
                }
              </div>
            </div>
            }

          </div>
        </div>


        <div class="row">
          <div class="col-12">
            <dx-button stylingMode="contained" class="mr-3" text="SALVA MATRICOLA" icon="save" type="success"
              (onClick)="SalvaMatricola($event)"> </dx-button>
          </div>
        </div>

      </dx-validation-group>
    </form>

  </dx-popup>

  @if (popupKit) {
  <dx-popup class="popup-kit" [width]="480" [height]="'auto'" [showTitle]="true" title="Gestione Kit"
    [dragEnabled]="false" [showCloseButton]="true" container=".dx-viewport" [(visible)]="popupKit">

    <div class="popup-kit-content">
      <p class="popup-kit-text">
        Vuoi aggiungere automaticamente i componenti del kit?
      </p>

      <div class="popup-kit-actions">
        <dx-button stylingMode="contained" text="Sì" type="success" (onClick)="onConfermaKit()" width="80">
        </dx-button>

        <dx-button stylingMode="contained" text="No" type="danger" (onClick)="onDiniegoKit()" width="80">
        </dx-button>
      </div>
    </div>

  </dx-popup>
  }

  <dx-load-panel shadingColor="rgba(0,0,0,0.4)" [(visible)]="visibleLoadPanel" [showIndicator]="true"
    [showPane]="true" [shading]="true" [hideOnOutsideClick]="false">
  </dx-load-panel>

  